import Badge from "./Badge";

const ListTags = ({ tags, mainTags, subTags, direction = "col" }) => {
  const colDirection = direction === "col" ? "flex-col" : "flex-row";

  if (tags) {
    return (
      <>
        <div className="flex flex-row gap-2">
          {tags.map((tag, index) => (
            <Badge
              key={`sub-${index}`}
              text={tag.name}
              type="genre-sub"
              href={`/search?page=1&q=${tag.name}&include=tags`}
            />
          ))}
        </div>
      </>
    );
  } else {
    return (
      <div className={`flex ${colDirection} gap-2`}>
        <Badge
          text={mainTags}
          type="genre-main"
          href={`/search?page=1&q=${mainTags}&include=tags`}
        />
        {subTags && subTags.length > 0 && (
          <>
            {subTags.map((tag, index) => (
              <Badge
                key={`sub-${index}`}
                text={tag.name}
                type="genre-sub"
                href={`/search?page=1&q=${tag.name}&include=tags`}
              />
            ))}
          </>
        )}
      </div>
    );
  }
};

export default ListTags;
